(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5929],{

/***/ 38348:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reviews",
      function () {
        return __webpack_require__(39622);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 59896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZE": function() { return /* binding */ getJsonLd; }
});

// UNUSED EXPORTS: setJsonLdAccommodation, setJsonLdBreadcrumb, setSameAsByMarket

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
;// CONCATENATED MODULE: ./client/components/JsonLd/constants.js
var jsonld = {
    "@context": "https://schema.org",
    "@type": "Organization",
    address: {
        "@type": "PostalAddress",
        addressCountry: "ES",
        addressLocality: "Barcelona",
        addressRegion: "Barcelona",
        postalCode: "08010",
        streetAddress: "Ronda Sant Pere 17, 3\xba 4\xaa"
    },
    founders: [
        {
            "@type": "Person",
            name: "Luis Osorio Sol\xe9"
        },
        {
            "@type": "Person",
            name: "Francesc L\xf3pez Castellet"
        },
        {
            "@type": "Person",
            name: "Ra\xfal Mor\xf3n Sillero"
        }, 
    ],
    foundingDate: "2015-01-29",
    foundingLocation: "Barcelona",
    legalName: "Stayforlong S.L.",
    logo: {
        "@type": "ImageObject",
        caption: "Stayforlong logo",
        url: "https://static.stayforlong.com/web/images/sfl-logo-mobile.jpg"
    },
    name: "Stayforlong",
    url: "https://www.stayforlong.com"
};
var descriptions = {
    es: "Stayforlong es un sitio web de reservas hoteleras especializado en las reservas de larga estancia. Se encuentra presente en 22 pa\xedses distintos y ofrece a sus clientes una cartera formada por m\xe1s de 720.000 establecimientos hoteleros. Stayforlong tiene su sede en la ciudad de Barcelona.",
    de: "Stayforlong ist eine Hotelreservierungswebseite spezialisiert auf Langzeitaufenthalte. Wir sind pr\xe4sent in 22 verschiedenen L\xe4ndern und bieten unseren Kunden ein Portfolio von mehr als 720.000 Hotels. Stayforlong hat den Hauptsitz in Barcelona.",
    fr: "Stayforlong est un portail de r\xe9servation d'h\xf4tels sp\xe9cialis\xe9 dans les longs s\xe9jours.Nous sommes pr\xe9sents dans 22 pays et proposons \xe0 nos utilisateurs plus de 720.000 h\xf4tels diff\xe9rents.",
    uk: "Stayforlong is a hotel reservation portal specialized in long stays. We are present in 22 countries and offer to our clients more than 720.000 different hotels. Stayforlong's headquarter is located in Barcelona, Spain.",
    pt: "Stayforlong \xe9 um portal de reservas de hot\xe9is especializado em estadias longas. Estamos presentes em 22 pa\xedses e oferecemos aos nossos usu\xe1rios mais de 720.000 hot\xe9is diferentes."
};
var sameAs = [
    "https://www.facebook.com/stayforlong",
    "https://www.instagram.com/stayforlong",
    "https://www.youtube.com/channel/UCXY0iWptc19iyKlVqkK1ZGw", 
];

// EXTERNAL MODULE: ./src/constants/countries.ts
var countries = __webpack_require__(83404);
;// CONCATENATED MODULE: ./client/components/JsonLd/mappers.js

function setAddress(param) {
    var street = param.street, locality = param.locality, region = param.region, _country = param.country, country = _country === void 0 ? DEFAULT_COUNTRY.market : _country, postalCode = param.postalCode;
    return {
        "@type": "PostalAddress",
        streetAddress: street,
        addressLocality: locality,
        addressRegion: region,
        postalCode: postalCode,
        addressCountry: country
    };
}
var setAmenities = function(amenities) {
    return amenities.map(function(amenity) {
        return {
            "@type": "LocationFeatureSpecification",
            value: "True",
            name: amenity.name
        };
    });
};
var mappers_mapJsonLdTypeDetail = function(accommodation, addressParam) {
    var accommodationType = accommodation.accommodationType, name = accommodation.name, url = accommodation.url, image = accommodation.photo, description = accommodation.description, latitude = accommodation.latitude, longitude = accommodation.longitude, rating = accommodation.rating, facilities = accommodation.facilities;
    return {
        "@context": "http://schema.org",
        "@type": accommodationType.toLowerCase(),
        name: name,
        url: url,
        image: image,
        description: description,
        address: setAddress(addressParam),
        geo: {
            "@type": "GeoCoordinates",
            latitude: latitude,
            longitude: longitude
        },
        starRating: {
            "@type": "http://schema.org/Rating",
            ratingValue: rating
        },
        amenityFeature: setAmenities(facilities)
    };
};
var mappers_mapJsonLdBreadcrumb = function(param) {
    var urlHome = param.urlHome, urlList = param.urlList, urlDetail = param.urlDetail, listTitle = param.listTitle, detailTitle = param.detailTitle;
    return {
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
            {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: urlHome
            },
            {
                "@type": "ListItem",
                position: 2,
                name: listTitle,
                item: urlList
            },
            {
                "@type": "ListItem",
                position: 3,
                name: detailTitle,
                item: urlDetail
            }, 
        ]
    };
};

;// CONCATENATED MODULE: ./client/components/JsonLd/utils.js





function setJsonLdBreadcrumb(params) {
    return JSON.stringify(mapJsonLdBreadcrumb(params));
}
function setJsonLdAccommodation(accommodation, addressParam) {
    return JSON.stringify(mapJsonLdTypeDetail(accommodation, addressParam));
}
function setSameAsByMarket(market) {
    var linkedinMarket = market !== "es" && market !== "de" && market !== "fr" && market !== "pt" ? "https://www.linkedin.com/company/stayforlong" : "https://".concat(market, ".linkedin.com/company/stayforlong");
    var twitterMarket = market === "es" ? "https://twitter.com/stayforlong_es" : "https://twitter.com/stayforlong";
    return (0,_to_consumable_array/* default */.Z)(sameAs).concat([
        linkedinMarket,
        twitterMarket
    ]);
}
function getJsonLd(market) {
    var jsonLdMarket = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, jsonld), {
        sameAs: setSameAsByMarket(market)
    });
    if (!descriptions[market]) {
        return JSON.stringify(jsonLdMarket);
    }
    return JSON.stringify((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, jsonLdMarket), {
        description: descriptions[market]
    }));
}


/***/ }),

/***/ 94837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_L": function() { return /* reexport safe */ _page__WEBPACK_IMPORTED_MODULE_1__._L; },
/* harmony export */   "oN": function() { return /* reexport safe */ _page__WEBPACK_IMPORTED_MODULE_1__.oN; },
/* harmony export */   "pv": function() { return /* reexport safe */ _scroll__WEBPACK_IMPORTED_MODULE_2__.p; }
/* harmony export */ });
/* unused harmony export toRelative */
/* harmony import */ var _country__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78735);
/* harmony import */ var _page__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96011);
/* harmony import */ var _scroll__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20539);



function toRelative(url) {
    return "/".concat(url.replace(/^(?:\/\/|[^/]+)*\//, ""));
}


/***/ }),

/***/ 20539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ scrollToPosition; }
/* harmony export */ });
/* unused harmony export getTop */
/* harmony import */ var _s4l_utils_library_rtl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75570);

function getTop(param) {
    var _y = param.y, y = _y === void 0 ? 0 : _y, ref = param.ref, _margin = param.margin, margin = _margin === void 0 ? 0 : _margin;
    var element = ref && "current" in ref ? ref.current : ref;
    if (!element || !element.getBoundingClientRect) return y;
    var scrollTop = (window === null || window === void 0 ? void 0 : window.scrollY) || document.documentElement.scrollTop;
    return element.getBoundingClientRect().top + scrollTop + margin;
}
function scrollToPosition() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _x = ref.x, x = _x === void 0 ? 0 : _x, _y = ref.y, y = _y === void 0 ? 0 : _y, ref1 = ref.ref, _margin = ref.margin, margin = _margin === void 0 ? 0 : _margin;
    if (false) {}
    var left = (0,_s4l_utils_library_rtl__WEBPACK_IMPORTED_MODULE_0__/* .rtlLeftNormalizer */ .Fs)(x);
    var top = getTop({
        y: y,
        ref: ref1,
        margin: margin
    });
    if ("scrollBehavior" in document.documentElement.style) {
        window.scrollTo({
            left: left,
            top: top,
            behavior: "smooth"
        });
    } else {
        window.scrollTo(left, top);
    }
    return null;
}


/***/ }),

/***/ 39622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ reviews; },
  "pageId": function() { return /* binding */ pageId; },
  "pagePathView": function() { return /* binding */ pagePathView; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@builder.io/react/dist/builder-react.es5.js
var builder_react_es5 = __webpack_require__(96204);
// EXTERNAL MODULE: ./src/pages/builder/LandingHeader/index.tsx + 5 modules
var LandingHeader = __webpack_require__(99899);
// EXTERNAL MODULE: ./src/pages/builder/styles.ts
var styles = __webpack_require__(3977);
// EXTERNAL MODULE: ./src/constants/subscriptionSources.js
var subscriptionSources = __webpack_require__(4077);
// EXTERNAL MODULE: ./client/components/Footer/index.tsx
var Footer = __webpack_require__(3066);
// EXTERNAL MODULE: ./src/context/search/index.tsx
var search = __webpack_require__(33500);
// EXTERNAL MODULE: ./src/context/topDestinations/index.tsx
var topDestinations = __webpack_require__(27606);
// EXTERNAL MODULE: ./src/comps/Page/index.js + 4 modules
var Page = __webpack_require__(77288);
// EXTERNAL MODULE: ./lib/utils/index.js
var utils = __webpack_require__(94837);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ./src/hooks/useMarket.ts
var useMarket = __webpack_require__(59806);
// EXTERNAL MODULE: ./client/components/JsonLd/utils.js + 2 modules
var JsonLd_utils = __webpack_require__(59896);
;// CONCATENATED MODULE: ./src/pages/reviews/head/index.tsx







function ReviewsHead() {
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,useMarket/* useMarket */.A)(), language = ref.language, market = ref.market, subdomain = ref.subdomain, topdomain = ref.topdomain;
    var title = "".concat(intl.formatMessage({
        id: "global.reviews-metatitle"
    }));
    var description = "".concat(intl.formatMessage({
        id: "page.reviews-metadescription"
    }));
    var canonicalURL = (0,utils/* buildCanonicalURL */._L)({
        market: market,
        language: language,
        pathname: "/reviews",
        subdomain: subdomain,
        topdomain: topdomain
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "canonical",
                href: canonicalURL
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                children: (0,JsonLd_utils/* getJsonLd */.ZE)(market)
            })
        ]
    });
}

// EXTERNAL MODULE: ../../packages/uikit/src/index.ts + 161 modules
var src = __webpack_require__(41281);
;// CONCATENATED MODULE: ./pages/reviews/index.tsx












var pagePathView = "/reviews";
var __N_SSP = true;

var pageId = "reviews";
/* harmony default export */ function reviews(props) {
    var config = props.config, builderContent = props.builderContent, amazingDestinations = props.amazingDestinations;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.Z, {
        config: config,
        pageId: pageId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewsHead, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(search/* SearchProvider */.X, {
                location: null,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(topDestinations/* TopDestinationsProvider */.I, {
                    value: {
                        destinations: amazingDestinations
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingHeader/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* LandingsContainer */.f, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_react_es5/* BuilderComponent */.VD, {
                                locale: config.locale,
                                model: "page",
                                content: builderContent
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(src.SubscriptionBox, {
                            source: subscriptionSources/* SUBSCRIPTION_BOX_REVIEWS_PAGE */.qX
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 99899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LandingHeader; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/constants/routes.js
var routes = __webpack_require__(54166);
// EXTERNAL MODULE: ../../packages/ds/src/index.ts + 108 modules
var src = __webpack_require__(79000);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ./src/comps/OmniSearch/index.tsx + 1 modules
var OmniSearch = __webpack_require__(77427);
// EXTERNAL MODULE: ./src/hooks/useDevice/index.ts
var useDevice = __webpack_require__(72731);
// EXTERNAL MODULE: ./src/hooks/useSearch.ts
var useSearch = __webpack_require__(36796);
// EXTERNAL MODULE: ./src/types/device.ts
var device = __webpack_require__(68686);
// EXTERNAL MODULE: ./src/types/search.ts
var search = __webpack_require__(50728);
// EXTERNAL MODULE: ./src/hooks/useSession.ts
var useSession = __webpack_require__(66334);
// EXTERNAL MODULE: ./client/components/HeaderWithSlots/index.tsx + 7 modules
var HeaderWithSlots = __webpack_require__(21103);
// EXTERNAL MODULE: ./client/components/HeaderLogo/index.tsx + 11 modules
var HeaderLogo = __webpack_require__(17379);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(3854);
// EXTERNAL MODULE: ./client/styles/index.js + 4 modules
var styles = __webpack_require__(89804);
;// CONCATENATED MODULE: ./src/comps/LoginNavigator/styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    position: absolute;\n    inset-block-start: 38px;\n    z-index: var(--z-high);\n    background-color: ",
        ";\n    inset-inline-start: calc(100% - 170px);\n    width: 200px;\n    box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.125);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-block: 20px;\n  padding-inline: 20px;\n  border-block-end: 1px solid ",
        ";\n\n  > h3 {\n    font-size: 20px;\n    font-weight: 700;\n    margin-block-end: 16px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  li {\n    border-block-end: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      font-weight: 500;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      font-weight: 700;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  display: block;\n  padding-block: 16px;\n  padding-inline: 16px;\n  text-decoration: none;\n\n  &:hover {\n    background-color: ",
        ";\n  }\n\n  ",
        "\n\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var LoginNavigatorBase = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    displayName: "styles__LoginNavigatorBase",
    componentId: "sc-adc88f8-0"
})(_templateObject(), styles/* media.tablet */.BC.tablet, styles/* colors.white */.O9.white);
var NavigatorHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__NavigatorHeader",
    componentId: "sc-adc88f8-1"
})(_templateObject1(), styles/* colors.grey6 */.O9.grey6);
var NavigatorList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "styles__NavigatorList",
    componentId: "sc-adc88f8-2"
})(_templateObject2(), styles/* colors.grey6 */.O9.grey6);
var Section = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    displayName: "styles__Section",
    componentId: "sc-adc88f8-3"
})(_templateObject5(), styles/* colors.grey6 */.O9.grey6, function(props) {
    return props.id === "link" && (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), styles/* colors.white */.O9.white, styles/* colors.grey1 */.O9.grey1);
}, function(props) {
    return props.id === "logout" && (0,styled_components_browser_esm/* css */.iv)(_templateObject4(), styles/* colors.white */.O9.white, styles/* colors.red */.O9.red);
});

;// CONCATENATED MODULE: ./src/comps/LoginButton/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  position: relative;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      color: var(--color--base--white);\n    "
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 21px;\n  line-height: 21px;\n  font-size: 14px;\n  font-weight: 700;\n  font-family: ",
        ";\n  color: var(--color--neutral--800);\n  ",
        "\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: var(--color--neutral--600);\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: var(--color--text--link--on-light);\n  cursor: pointer;\n  text-decoration: underline;\n\n  &:hover {\n    text-decoration: none;\n  }\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var LoginButtonBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__LoginButtonBase",
    componentId: "sc-92e25e12-0"
})(styles_templateObject());
var LoginButtonLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    displayName: "styles__LoginButtonLink",
    componentId: "sc-92e25e12-1"
})(styles_templateObject1());
var LoginLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__LoginLabel",
    componentId: "sc-92e25e12-2"
})(styles_templateObject3(), styles/* fonts.default */.Rq["default"], function(props) {
    return props.isEbooking && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject2());
});
var CheckoutLabel = (0,styled_components_browser_esm/* default */.ZP)(LoginLabel).withConfig({
    displayName: "styles__CheckoutLabel",
    componentId: "sc-92e25e12-3"
})(styles_templateObject4());
var LoginTextLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    displayName: "styles__LoginTextLink",
    componentId: "sc-92e25e12-4"
})(styles_templateObject5());

;// CONCATENATED MODULE: ./client/components/MinimalHeader/styles.tsx

function MinimalHeader_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex: 1 0 auto;\n  justify-content: flex-end;\n  position: relative;\n  gap: 8px;\n\n  ",
        " {\n    ",
        " {\n      position: absolute;\n      inset-block-start: 38px;\n      z-index: var(--z-high);\n      background-color: ",
        ";\n    }\n\n    ",
        " {\n      inset-inline-start: calc(100% - 170px);\n      width: 200px;\n      box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.125);\n    }\n  }\n  ",
        " {\n    gap: 16px;\n  }\n"
    ]);
    MinimalHeader_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MinimalHeader_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        " {\n        margin-inline-end: 0;\n      }\n    "
    ]);
    MinimalHeader_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MinimalHeader_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 8px;\n  ",
        "\n  ",
        " {\n    gap: 16px;\n  }\n\n  ",
        " {\n    height: 40px;\n  }\n"
    ]);
    MinimalHeader_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var UserActions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__UserActions",
    componentId: "sc-c0ffd013-0"
})(MinimalHeader_styles_templateObject(), styles/* media.tablet */.BC.tablet, LoginNavigatorBase, styles/* colors.white */.O9.white, LoginNavigatorBase, styles/* updatedMedia.tablet */.$c.tablet);
var RightSideWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__RightSideWrapper",
    componentId: "sc-c0ffd013-1"
})(MinimalHeader_styles_templateObject2(), function(param) {
    var isSearch = param.isSearch;
    return isSearch && (0,styled_components_browser_esm/* css */.iv)(MinimalHeader_styles_templateObject1(), LoginButtonBase);
}, styles/* updatedMedia.tablet */.$c.tablet, styles/* updatedMedia.desktop */.$c.desktop);

// EXTERNAL MODULE: ./src/comps/LoginButton/index.tsx + 3 modules
var LoginButton = __webpack_require__(65559);
// EXTERNAL MODULE: ./client/components/CountrySelector/index.tsx + 2 modules
var CountrySelector = __webpack_require__(59813);
// EXTERNAL MODULE: ../../packages/icons/lib/IconArrowLeft.tsx
var IconArrowLeft = __webpack_require__(38062);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
;// CONCATENATED MODULE: ./client/components/MinimalHeader/index.tsx













function MinimalHeader(props) {
    var center = props.center, bottom = props.bottom, fixed = props.fixed, pageId = props.pageId;
    var currentUserHasPrimeSubscription = (0,useSession/* useSession */.k)().currentUserHasPrimeSubscription;
    var activeBreakpoint = (0,useDevice/* useDevice */.F)().activeBreakpoint;
    var router = (0,next_router.useRouter)();
    var showLogo = function() {
        if (activeBreakpoint < device/* BreakpointSizes.M */.a.M) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Button */.zx, {
                variant: "icon-rounded",
                size: "small",
                leadingIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconArrowLeft/* IconArrowLeft */.D, {}),
                onClick: router.back
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderLogo/* default */.Z, {
            pageId: pageId,
            isPrime: currentUserHasPrimeSubscription
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderWithSlots/* default */.Z, {
        left: showLogo(),
        center: center,
        right: /*#__PURE__*/ (0,jsx_runtime.jsx)(RightSideWrapper, {
            isSearch: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserActions, {
                children: [
                    activeBreakpoint >= device/* BreakpointSizes.M */.a.M && /*#__PURE__*/ (0,jsx_runtime.jsx)(CountrySelector/* CountrySelector */.P, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginButton/* default */.Z, {})
                ]
            })
        }),
        bottom: bottom,
        fixed: fixed
    });
}
/* harmony default export */ var components_MinimalHeader = (MinimalHeader);

// EXTERNAL MODULE: ./client/components/OmniSearchHeader/styles.module.css
var styles_module = __webpack_require__(5304);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./client/components/OmniSearchHeader/index.tsx











var OmniSearchSmall = function(param) {
    var searchUrl = param.searchUrl, preventNavigation = param.preventNavigation, onClick = param.onClick;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(src/* BottomSheet */.R1, {
        snapPoints: [],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* BottomSheet.Trigger */.R1.Trigger, {
                className: (styles_module_default()).omnisearchSmall,
                "data-testid": "omnisearch-btn",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OmniSearch/* default */.Z, {
                    mode: search/* SearchMode.Readonly */.N3.Readonly,
                    searchUrl: searchUrl,
                    preventNavigation: preventNavigation
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* BottomSheet.Content */.R1.Content, {
                title: intl.formatMessage({
                    id: "modify.search"
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OmniSearch/* default */.Z, {
                    mode: search/* SearchMode.Full */.N3.Full,
                    searchUrl: searchUrl,
                    preventNavigation: preventNavigation,
                    onClick: onClick
                })
            })
        ]
    });
};
function OmniSearchHeader(props) {
    var ref = (0,useSearch/* useSearch */.R)(), newSearchUrl = ref.searchUrl;
    var bottom = props.bottom, pageId = props.pageId, fixed = props.fixed, preventNavigation = props.preventNavigation, _searchUrl = props.searchUrl, searchUrl = _searchUrl === void 0 ? newSearchUrl : _searchUrl;
    var activeBreakpoint = (0,useDevice/* useDevice */.F)().activeBreakpoint;
    var render = /*#__PURE__*/ (0,jsx_runtime.jsx)(OmniSearchSmall, {
        searchUrl: searchUrl,
        preventNavigation: preventNavigation
    });
    if (activeBreakpoint >= device/* BreakpointSizes.L */.a.L) {
        render = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (styles_module_default()).omnisearchLarge,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OmniSearch/* default */.Z, {
                searchUrl: searchUrl,
                mode: search/* SearchMode.Borderless */.N3.Borderless,
                preventNavigation: preventNavigation,
                smallBtn: true
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MinimalHeader, {
        center: render,
        bottom: bottom,
        pageId: pageId,
        fixed: fixed
    });
}
/* harmony default export */ var components_OmniSearchHeader = (OmniSearchHeader);

;// CONCATENATED MODULE: ./src/pages/builder/LandingHeader/index.tsx





var pageId = routes/* routes.landings.page */._.landings.page;
var LandingsHeader = function() {
    var oldSearchUrl = (0,useSearch/* useSearch */.R)().oldSearchUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_OmniSearchHeader, {
        pageId: pageId,
        bottom: null,
        fixed: true,
        preventNavigation: false,
        searchUrl: oldSearchUrl
    });
};
/* harmony default export */ var LandingHeader = (LandingsHeader);


/***/ }),

/***/ 3977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ LandingsContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var client_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89804);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3854);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  a {\n    text-decoration: none;\n  }\n\n  margin-block-start: 57px;\n\n  ",
        " {\n    margin-block-start: 65px;\n  }\n\n  ",
        " {\n    margin-block-start: 89px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var LandingsContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__LandingsContainer",
    componentId: "sc-3229c455-0"
})(_templateObject(), client_styles__WEBPACK_IMPORTED_MODULE_1__/* .updatedMedia.tablet */ .$c.tablet, client_styles__WEBPACK_IMPORTED_MODULE_1__/* .updatedMedia.desktop */ .$c.desktop);


/***/ }),

/***/ 5304:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"omnisearchSmall":"styles_omnisearchSmall__8eIk2","omnisearchLarge":"styles_omnisearchLarge__co0NL"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2522,3053,7427,9774,2888,179], function() { return __webpack_exec__(38348); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);